export default __webpack_public_path__ + "static/USBgImg-3bd80d76f89ae4afc4797a4eb97709c9.png";